import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse, LoadState } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { HomeworkInfo } from "./homeworkSlice";

export interface HomeworkClassroomListState {
    state: LoadStateInfo;
    request?: RetrieveHomeworkClassroomListRequest;
    list?: HomeworkInfo[];
}

const initialState: HomeworkClassroomListState = {
    state: notStarted(),
};


export interface RetrieveHomeworkClassroomListRequest {
    classroomId: string;
}
export const retrieveHomeworkClassroomList = createAsyncThunk(
    "retrieveHomeworkClassroomList",
    async (param: RetrieveHomeworkClassroomListRequest, thunkAPI) => {
        console.debug(`retrieve homework for classroom ${param.classroomId}`);

        const response = await fetch(`${getBackendUrl()}/api/homework/classroom/${param.classroomId}`, {
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
            }
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    {
        condition: (param: RetrieveHomeworkClassroomListRequest, thunkAPI) => {
            const state = thunkAPI.getState() as RootState;
            const status = state.homeworkClassroomList;
            if (!status || !status.state) {
                return true;
            }
            if (status.state.state == LoadState.NotStarted) {
                return true;
            }
            console.debug(`retrieveHomeworkClassroomList skipped: ${status.state.state}`);
            return false;
        }
    }
);


export const homeworkClassroomListSlice = createSlice({
    name: "homeworkClassroomList",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        check: (state, action: PayloadAction<RetrieveHomeworkClassroomListRequest>) => {
            if (state.state.state != LoadState.NotStarted
                && (state.request && state.request.classroomId != action.payload.classroomId)
            ) {
                console.debug(`homework classroom list not retrieved for classroom ${action.payload.classroomId}`);
                state.state = notStarted();
                state.request = action.payload;
                state.list = undefined;
            }
        },
        clean: (state) => {
            state.state = notStarted();
            state.list = undefined;
        }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(retrieveHomeworkClassroomList.pending, (state, action) => {
                state.state = loading();
                state.list = undefined;
                state.request = action.meta.arg;
            })
            .addCase(retrieveHomeworkClassroomList.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                state.state = loaded();
                state.list = action.payload;
                // state.list?.sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));
            })
            .addCase(retrieveHomeworkClassroomList.rejected, (state, action) => {
                state.state = error(action);
            })
            ;
    },
});

// export const { } = routineRecordListSlice.actions;

export const selectHomeworkClassroomList = (state: RootState) => state.homeworkClassroomList;

export default homeworkClassroomListSlice.reducer;
